// extracted by css-extract-rspack-plugin
export default {"xp-bar-bg":"xp-bar-bg-Ugs21v","xpBarBg":"xp-bar-bg-Ugs21v","xp-bar":"xp-bar-Vg4hn0","xpBar":"xp-bar-Vg4hn0","xp-label":"xp-label-omcEHZ","xpLabel":"xp-label-omcEHZ"};